export enum SellerStateEnum {
    Active = 1,
    Inactive = 2,
  }
  